import Swiper from "swiper/bundle";
import $ from "jquery";

const editorsChoice = {
  variables: {
    thumbnailSwiper: null,
      url: window.location.href,
  },
  methods: {
    initializeSwiper: function () {
      editorsChoice.variables.thumbnailSwiper = new Swiper(
        ".thumbnail-swiper",
        {
          loop: true,
          spaceBetween: 22,
          slidesPerView: 1.5,
          effect: "coverflow",
          grabCursor: false,
          centeredSlides: true,

          coverflowEffect: {
            slideShadows: false,
          },

          navigation: {
            nextEl: ".swiper-btn-min-next",
            prevEl: ".swiper-btn-min-prev",
          },

          breakpoints: {
            768: {
              spaceBetween: 44,
              slidesPerView: 3,
              freeMode: true,
              watchSlidesProgress: true,
              effect: "slide",
              centeredSlides: false,
            },
            850: {
              spaceBetween: 44,
              slidesPerView: 4,
              freeMode: true,
              watchSlidesProgress: true,
              effect: "slide",
              centeredSlides: false,
            },
            1200: {
              spaceBetween: 44,
              slidesPerView: 5,
              freeMode: true,
              watchSlidesProgress: true,
              effect: "slide",
              centeredSlides: false,
            },
          },
        }
      );
      const swiper2 = new Swiper(".large-swiper", {
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-btn-max-next",
          prevEl: ".swiper-btn-max-prev",
        },
        thumbs: {
          swiper: editorsChoice.variables.thumbnailSwiper,
        },
      });
    },
    dataLayerObj : function(e) {
        var obj = {
            'articleName' : "",
            'blogCategory' : "",
            'blogPageCategory' : "",
            'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
            'pageSection' : "Editor Choice",
            'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? editorsChoice.variables.url.includes("blog") ? "Blogs" : editorsChoice.variables.url.substring(editorsChoice.variables.url.indexOf(".com/"), editorsChoice.variables.url.lastIndexOf('/')  === ".com") && !editorsChoice.variables.url.substring(editorsChoice.variables.url.indexOf(".com/"), editorsChoice.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
            'planOption' : "",
            'productCategory' : "",
            'productName' : "",
            'question' : "",
            'searchTerm' : "",
            'videoTitle' : "",
            'bannerName' : "",
            'bannerType' : ""
        };
        return obj;
    }
  },
};

$(() => {
  editorsChoice.methods.initializeSwiper();
  $(".editors-choice--common-cta").on('click', function(e){
        let obj = editorsChoice.methods.dataLayerObj(e);
        createDataLayer("buttonClick", obj);
  });
});
